export const ECreatorShopLnbMenu = {
  /** 고정 영역 */
  ShopHome: 'shop_home',
  /**
   * - 공개 상품이 있을 경우 노출
   * - 영문/일문 페이지에서 미노출
   */
  Challenges: 'challenges',
  /** 공개 상품이 있을 경우 노출 */
  Goods: 'goods',
  /**
   * - 공개 상품이 있을 경우 노출
   * - 영문/일문 페이지에서 미노출
   */
  Handmade: 'handmade',
  /**
   * - 공개 상품이 있을 경우 노출
   * - 영문/일문 페이지에서 미노출
   */
  BrandDeal: 'brand_deal',
  /**
   * - 공개 상품이 있을 경우 노출
   * - 영문/일문 페이지에서 미노출
   */
  Ebook: 'ebook',
  /**
   * - 멤버십 등록 시 노출
   * - 영문/일문 페이지에서 미노출
   */
  Membership: 'membership',
  /**
   * - 커미션 등록 시 노출
   * - 영문/일문 페이지에서 미노출
   */
  Commission: 'commission',
  /**
   * - 후원 등록 시 노출
   * - 영문/일문 페이지에서 미노출
   */
  Support: 'support',
  /**
   * - 고정 영역
   * - 팬레터가 0개 일 시 숫자 미노출
   */
  FanLetter: 'fan_letter',
  /**
   * - 리뷰 수 > 0 일때 노출
   */
  Review: 'review',
} as const;

export type ECreatorShopLnbMenu = (typeof ECreatorShopLnbMenu)[keyof typeof ECreatorShopLnbMenu];
